import styled from "styled-components";

export const BaseFrameWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
`;
